<template>
  <PageWrapper bodyClass="page-wrapper__content">
    <template>
      <EvidenceForm
        :item="item"
        :parentLoading="getLoading"
        :submitButtonText="$lang.correction"
        @submit="editEvidenceData"
      />
    </template>
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/components/re-design/wrappers/PageWrapper.vue";
import EvidenceForm from "./forms/EvidenceForm.vue";
import { pathOr } from "ramda";
import { getOneEvidence, editEvidence } from "@/modules/kanoon/services";
import { goToRoute } from "@/shared/utils";

export default {
  components: { PageWrapper, EvidenceForm },
  data() {
    return {
      item: null,
      getLoading: false,
    };
  },
  created() {
    this.getEvidenceData();
  },
  methods: {
    pathOr,
    goToRoute,
    backToEvidenceList() {
      goToRoute("evidence", {}, {}, false);
    },
    async getEvidenceData() {
      try {
        this.getLoading = true;
        const evidenceId = this.$route.params.id;
        const response = await getOneEvidence(evidenceId);
        const {
          exercise,
          indicator,
          evidence,
          captionThirdPerson,
          captionImperative,
          status,
        } = response;

        this.item = {
          exercise,
          indicator,
          evidence,
          captionThirdPerson,
          captionImperative,
          status,
        };
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.getLoading = false;
      }
    },
    async editEvidenceData(
      exerciseId,
      indicatorId,
      secondPersonEvidence,
      captionThirdPerson,
      captionImperative,
      status,
      callback
    ) {
      try {
        const evidenceId = this.$route.params.id;
        const response = await editEvidence(
          evidenceId,
          exerciseId,
          indicatorId,
          secondPersonEvidence,
          captionThirdPerson,
          captionImperative,
          status
        );
        const { message } = response;
        this.$notify.success(message);
        this.backToEvidenceList();
      } catch (error) {
        this.$generateError(error);
      } finally {
        callback();
      }
    },
  },
};
</script>
